import React from 'react';
import { SdmSpacer, SdmTypography } from 'components';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { styled } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/styles';
import { TextField } from '@material-ui/core';
import { theme } from 'theme';
import { format, intlFormat } from 'date-fns';
import { useDataHelper } from 'utils/dataHelper';

const StyledIconButton = styled(IconButton)({
  padding: 5,
});

const CustomFormTextField = withStyles({
  root: {
    width: '90%',
    marginLeft: 8,
    '& .MuiFormControl-root': {
      width: '95%',
    },
    '& label.Mui-focused': {
      color: `${theme.colors.primary.black}`,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: `${theme.colors.primary.black}`,
    },
    '& .MuiInput-underline:before': {
      borderBottom: `2px solid ${theme.colors.primary.black}`,
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Suisse-Intl',
      fontSize: 26,
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Suisse-Intl',
      color: `${theme.colors.primary.black}`,
      fontSize: 21,
    },
  },
})(TextField);

const ViewDialog = ({ onClose, i18n, isSmDown, slot, locale }) => {
  // Hooks
  const dataHelper = useDataHelper();
  // Functions
  const handleOverflowBody = () => {
    const bodyStatus = document.body.getAttribute('style');
    if (bodyStatus.includes('overflow: hidden')) {
      document.body.style.overflow = 'visible';
      document.body.style.paddingTop = 79;
    }
  };

  const handleClose = () => {
    handleOverflowBody();
    onClose && onClose();
  };

  // Constants
  const date = intlFormat(
    new Date(slot?.start),
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    },
    {
      locale: dataHelper.getLangCode(locale),
    }
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      // maxWidth={300}
      PaperProps={{
        style: {
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 80,
          paddingBottom: 50,
        },
      }}
    >
      <div
        tabIndex={0}
        role="button"
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: 24,
          right: 24,
        }}
      >
        <StyledIconButton>
          <CloseIcon fontSize={isSmDown ? 'large' : 'small'} />
        </StyledIconButton>
      </div>
      <Grid container>
        <Grid item xs={12}>
          <SdmTypography
            variant={'h3'}
            style={{ textTransform: 'uppercase' }}
            margin={0}
            textAlign={'center'}
          >
            {i18n.subtitle}
          </SdmTypography>
          <SdmSpacer height={20} />
          <SdmTypography variant={'h1'} margin={0} textAlign={'center'}>
            {i18n.title}
          </SdmTypography>
          <SdmSpacer height={40} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <CustomFormTextField
            value={date}
            label={`${i18n.date.label}`}
            style={{ marginBottom: 30 }}
            disabled={true}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <CustomFormTextField
            value={slot.slotCapacity}
            label={`${i18n.slotCapacity.label}`}
            style={{ marginBottom: 30 }}
            disabled={true}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <CustomFormTextField
            value={format(new Date(slot.start), 'HH:mm')}
            label={`${i18n.start.label}`}
            style={{ marginBottom: 30 }}
            disabled={true}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <CustomFormTextField
            value={format(new Date(slot.end), 'HH:mm')}
            label={`${i18n.end.label}`}
            style={{ marginBottom: 30 }}
            disabled={true}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ViewDialog;
